import { productNameSchema, type ProductName } from '@inkitt/contracts-common';
import { z } from 'zod';

export const productsQuerySchema = z
  .string()
  .transform((value) => value.split(',').map((product) => product.trim()))
  .pipe(z.array(productNameSchema).nonempty());

export const serializeProductsQueryParam = (products: readonly ProductName[]) => products.join(',');
